import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import green from '@material-ui/core/colors/green';
import grey from '@material-ui/core/colors/grey';
import Button from '@material-ui/core/Button';
import {useDispatch, useSelector} from "react-redux";
import {
  putComplianceAssessmentAction,
} from "../../../actions";
import red from "@material-ui/core/colors/red";
import {bbExtractAssessmentScore, bbIsObject} from "../../../util/bbHelpers";
import {ButtonGroup, Tooltip} from "@material-ui/core";
import BBIconCheckboxNo from "../../../assets/bbCustomIcons/BBIconCheckboxNo";
import BBIconCheckboxPartial from "../../../assets/bbCustomIcons/BBIconCheckboxPartial";
import BBIconCheckboxCheckedYes from "../../../assets/bbCustomIcons/BBIconCheckboxCheckedYes";


const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  wrapper: {
    // margin: theme.spacing(1),
    position: 'relative',
  },
  color1: {
    backgroundColor: green[500],
    color: grey[50],
    '&:hover': {
      backgroundColor: green[700],
    },
  },
  color2: {
    backgroundColor: red[500],
    color: grey[50],
    '&:hover': {
      backgroundColor: red[700],
    },
  },
  fabProgress: {
    color: green[500],
    position: 'absolute',
    top: -7,
    left: -7,
    zIndex: 1,
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -14,
    marginLeft: -14,
  },
});

const ToggleButton = (props) => {

  const {classes, customerId, complianceStandardId, controlId, assessmentSourceId} = props;
  // const {customers,} = useSelector(({customer}) => customer);
  const {customerAssessments, complianceTogglesLoading, complianceTogglesFail} = useSelector(({compliance}) => compliance);
  const [localLoading, setLocalLoading] = useState(false);
  const [newAssessmentIdWillBe, setNewAssessmentIdWillBe] = useState(null);
  const assessments = customerAssessments ? customerAssessments[customerId] ? customerAssessments[customerId] : null : null;
  // const isAssessmentsLoaded = bbIsObject(assessments) ? bbIsObject(assessments[complianceStandardId]) ? bbIsObject(assessments[complianceStandardId][controlId]) ? assessments[complianceStandardId][controlId] : null : null : null;

  // const assessments = customers ? customerAssessments ? customerAssessments[customerId] ? customerAssessments[customerId] : null : null : null;
  // //assessment group are all of the recent assessments. should contain last official, last self, and last third-pary assessment
  // const assessmentGroup = assessments ? assessments[controlId] ? assessments[controlId] : null : null;

  const assessmentPropertyState = () => {
    //figure out if there is an assessment with the property assessment source id
    return bbExtractAssessmentScore(assessments, complianceStandardId, controlId, assessmentSourceId);
  }

  const dispatch = useDispatch();

  useEffect(() => {
    // console.log("printing complianceTogglesLoading, ", complianceTogglesLoading);
    //check for this customer and this target's loader.
    const isLoading = complianceTogglesLoading[customerId] ? complianceTogglesLoading[customerId][controlId] ? complianceTogglesLoading[customerId][controlId] : null : null;
    const isError = complianceTogglesFail[customerId] ? complianceTogglesFail[customerId][controlId] ? complianceTogglesFail[customerId][controlId] : null : null;

    if (!isLoading || isError) {
      setLocalLoading(false);
    }
  }, [dispatch, complianceTogglesLoading, complianceTogglesFail, controlId, customerId]);

  const handleButtonClick = (newStatus) => {
    if (!localLoading) {
      if (assessments) {
        switch (assessmentSourceId) {
          case 1:
            setLocalLoading(true);
            setNewAssessmentIdWillBe(newStatus);

            dispatch(putComplianceAssessmentAction(
                {
                  "customerId": customerId,
                  "standardId": complianceStandardId,
                  "controlId": controlId,
                  "assessmentStatusId": newStatus === assessmentPropertyState() ? 4 : newStatus,
                  "assessmentSourceId": assessmentSourceId,
                }));
            break;

          default:
            break;
        }
      }
    }
  };

  const assessmentPropertyIconArray = (assessmentPropertyState) => {
    //show three icons/buttons, but only one can be illuminated, and the other two can be clicked.
    // console.log("creating array of buttons for control ", controlId, "state:", assessmentPropertyState)

    //not met is a targetPropertyState of 1
    const notMetButton =
        <Tooltip title={"Not Met"}>
            <Button
                variant={assessmentPropertyState === 1 ? "contained" : "outlined"}
                color="default"
                disableElevation
                className={assessmentPropertyState === 1 ? "bg-bb-risk-highest text-white" : ""}
                onClick={() => handleButtonClick(1)}
                disabled={localLoading}
            >
              <div className={classes.wrapper}>
                 {localLoading && (newAssessmentIdWillBe === 1) && <CircularProgress size={28} disableShrink className={classes.buttonProgress}/>}
                 <BBIconCheckboxNo />
              </div>
            </Button>
        </Tooltip>


    //partial met is a targetPropertyState of 2
    const partiallyMetButton =
        <Tooltip title={"Partially Met"}>
          <Button
              variant={assessmentPropertyState === 2 ? "contained" : "outlined"}
              color="default"
              disableElevation
              className={assessmentPropertyState === 2 ? "bg-bb-risk-medium text-dark" : ""}
              onClick={ () => handleButtonClick(2)}
              disabled={localLoading}
          >
            <div className={classes.wrapper}>
              {localLoading && (newAssessmentIdWillBe === 2) && <CircularProgress size={28} disableShrink className={classes.buttonProgress}/>}
              <BBIconCheckboxPartial />
            </div>
          </Button>
        </Tooltip>


    //partial met is a targetPropertyState of 2
    const fullyMetButton =
        <Tooltip title={"Fully Met"}>
          <Button
              variant={assessmentPropertyState === 3 ? "contained" : "outlined"}
              color="default"
              disableElevation
              className={assessmentPropertyState === 3 ? "bg-bb-risk-lowest text-white" : ""}
              onClick={() => handleButtonClick(3)}
              disabled={localLoading}
          >
            <div className={classes.wrapper}>
              {localLoading && (newAssessmentIdWillBe === 3) && <CircularProgress size={28} disableShrink className={classes.buttonProgress}/>}
              <BBIconCheckboxCheckedYes />
            </div>
          </Button>
        </Tooltip>

    // return <>
    //   {notMetButton}
    //   {partiallyMetButton}
    //   {fullyMetButton}
    // </>

    return <ButtonGroup size="small" color="secondary" aria-label="small outlined button group">
      {notMetButton}
      {/*<Button variant="contained" color="primary" ><BBIconCheckboxNo /></Button>*/}
      {/*<Button>Partial</Button>*/}
      {partiallyMetButton}
      {fullyMetButton}
    </ButtonGroup>
  }

  // const buttonClassname = classNames({
  //   // [classes.color1]: flipColorLogic? !userPropertyState : userPropertyState,
  //   [classes.color2]: flipColorLogic? targetPropertyState : !targetPropertyState,
  // });

  return (
      <div className={`${classes.root}`}>
        {bbIsObject(assessments)
          ? assessmentPropertyIconArray(assessmentPropertyState())
          : "Loading..."
        }
      </div>

  );

}

ToggleButton.propTypes = {
  classes: PropTypes.object.isRequired,
  customerId: PropTypes.string.isRequired,
  controlId: PropTypes.string.isRequired,
  complianceStandardId: PropTypes.string.isRequired,
  assessmentSourceId: PropTypes.number.isRequired,
};

export default withStyles(styles)(ToggleButton);